export const DEFAULT_QUERIES_OPTIONS = {
    shallow: true,
}
